































































































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Quote } from '@/modules/Quote/interfaces/quote'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import S3Handler from '@/mixins/s3'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import VehicleDialog from '@/modules/Vehicle/scripts/vehicle-dialog'
import InsuredDialog from '@/modules/Insured/scripts/insured-dialog'
import PropertyDialog from '@/modules/Property/scripts/property-dialog'
import { translateInsuredRelatioKey } from '@/utils/translate'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'
import dollarFilter from '@/utils/dollarFilter'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { showOwnershipLabel } from '@/modules/Vehicle/helpers/vehicle-ownership-options'
import { showUseageLabel } from '@/modules/Vehicle/helpers/vehicle-useage-options'

@Component({
  components: {
    FoldingCard,
    AppFileUploader,
    AppAttachmentsCard
  }
})
export default class QuoteDetailRelated extends mixins(PolicyDialog, S3Handler, VehicleDialog, InsuredDialog, PropertyDialog) {
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  policyStatusClass = policyStatusClass
  showOwnershipLabel = showOwnershipLabel
  showUseageLabel = showUseageLabel

  policyTableColumn = [
    { field: 'policyNumber',
      title: 'Policy Number',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.policyNumber || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'policyName',
      title: 'Policy Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'status', title: 'Status', slots: { default: 'status_default' }, resizable: true, width: 150 },
    { field: 'carrierName',
      title: 'Carrier',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.carrier ? row.carrier.name : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'premium',
      title: 'Premium',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.premium ? dollarFilter(row.premium) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'effectiveDate',
      title: 'Effcetive Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.effectiveDate ? dateToDisplay(row.effectiveDate) : '-')
        ]
      }
      },
      width: 150
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.expirationDate ? dateToDisplay(row.expirationDate) : '-')
        ]
      }
      },
      width: 150
    },
    { field: 'actions', title: 'Actions', slots: { default: 'policy_action_default' }, fixed: 'right', width: 90 }
  ]

  vehicleTableColumn = [
    { field: 'name',
      title: 'Vehicle Name',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', { class: 'text-emphasize' }, row.name)
        ]
      }
      },
      resizable: true
    },
    { field: 'vin',
      title: 'VIN',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.vin)
        ]
      }
      },
      resizable: true
    },
    { field: 'ownership',
      title: 'Ownership',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', showOwnershipLabel(row.ownership))
        ]
      }
      }
    },
    { field: 'useage',
      title: 'Useage',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', showUseageLabel(row.useage))
        ]
      }
      }
    },
    { field: 'year',
      title: 'Year',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.year)
        ]
      }
      },
      resizable: true
    },
    { field: 'model',
      title: 'Model',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.model)
        ]
      }
      }
    }
  ]

  propertyTableColumn = [
    { field: 'address',
      title: 'Address',
      slots: { default: 'address_default' },
      resizable: true
    },
    { field: 'city',
      title: 'City',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.city || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'state',
      title: 'State',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.state || '-')
        ]
      }
      }
    }
  ]

  insuredTableColumn = [
    { field: 'name',
      title: 'Insured Name',
      slots: { default: 'insured_name_default' },
      resizable: true
    },
    { field: 'relationShip',
      title: 'Relationship',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.relationShip ? translateInsuredRelatioKey(row.relationShip) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'dateOfBirth',
      title: 'Date Of Birth',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.dateOfBirth || '-')
        ]
      }
      }
    }
  ]

  policyStatus = policyStatus

  get policyList () {
    return this.quote.policies || []
  }

  get attachmentList () {
    return this.quote.attachments || []
  }

  get showAuto () {
    if (!this.quote) {
      return false
    }
    const { name } = this.quote.recordType

    return name.indexOf('Auto') !== -1
  }

  get vehicles () {
    if (!this.quote) {
      return []
    }

    return this.showAuto
      ? this.quote.vehicles
      : []
  }

  get insureds () {
    if (!this.quote) {
      return []
    }

    return this.quote.insureds
  }

  get properties () {
    if (!this.quote) {
      return []
    }

    return this.quote.properties
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  async deletePolicyConfirm () {
    await this.deletePolicyPost()
    this.onSuccess()
  }

  routeToAllList (type: string) {
    this.$router.push({
      name: 'QuoteRelatedPoliciesList',
      params: {
        id: this.quote.id + ''
      }
    })
  }

  newVehicle (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showVehicleEditDialog(e)
  }

  newInsured (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showInsuredEditDialog(e)
  }

  newProperty (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showPropEditDialog(e)
  }

  clearForm () {
    this.hideVehicleEditDialog()
    this.hideInsuredEditDialog()
    this.hidePropEditDialog()
  }

  routeToList (routeName: string) {
    this.$router.push({
      name: routeName,
      params: {
        quoteId: this.quote.id + ''
      }
    })
  }

  routeToPropertyDetail (item: any) {
    this.$router.push({
      name: 'PropertyDetailDetail',
      params: { id: item.id + '' }
    })
  }

  routeToInsuredDetail (item: any) {
    this.$router.push({
      name: 'InsuredDetailDetail',
      params: { id: item.id + '' }
    })
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  mergeCellMethod ({ row, _rowIndex, column, visibleData }: any) {
    const fields = ['name']
    const cellValue = row[column.property]
    if (cellValue && fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow['acordFormId'] === row['acordFormId']) {
        return { rowspan: 0, colspan: 0 }
      } else {
        let countRowspan = 1
        while (nextRow && nextRow['acordFormId'] === row['acordFormId']) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return { rowspan: countRowspan, colspan: 1 }
        }
      }
    }
  }

  cellClassName (data: any) {
    if (data.column.property === 'name') {
      return 'file-name-cell'
    }
  }

  editPolicy (e: Event, policy: Policy) {
    e.preventDefault()
    e.stopPropagation()
    this.showPolicyEditDialog(0, policy)
  }
}
